module.exports = __webpack_public_path__ + "static/media/maths2.e0091dd9.jpg";